import { put, call, takeEvery, takeLatest, take } from 'redux-saga/effects'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import { toast } from 'react-toastify';

import Actions from '../Actions/Creators'
import Types from '../Actions/Types'
import Phi from '../Phi/Phi'
import CONSTANTS from './../Phi/Constants'


function* handleLogin(action) {
    const { username, password } = action.payload

    const credentials = { username, password }
    try {
        const response = yield call(Phi.User.login, Phi.User, credentials)

        if (response && response.profile) {
            // Persistent Login by saving the JWT token in cookies
            if(action.persistent.selected) {
            let cookies = action.persistent.cookies
            cookies.set('token', JSON.stringify(Phi.getSession()), {path: '/'})
            cookies.set('profile', Phi.Storage.getItem('profile'), {path: '/'})
            cookies.set('custom', Phi.Storage.getItem('custom'), {path: '/'});
            cookies.set('roles', Phi.Storage.getItem('roles'), {path: '/'})
            }

            yield put(Actions.loginResponse({ok: true, error: false, message: 'Logged In Successfully' }))
        }
        else if (!!!response.ok && !!response.error && response.errorCode === 403) {
            yield put(Actions.loginResponse({ok: false, error: true, errorCode: 403, message: 'Authorization failure: User is not authorized'}))
        }
        else {
            yield put(Actions.loginResponse({ok: false, error: true, errorCode: 401, message: 'Authentication failure. Incorrect username or password'}))
        }
    }
    catch(e) {
        const response = { ok: false, error: true, errorCode: 500, message: 'Something went wrong'}
        yield put(Actions.loginResponse(response))
    }
}


function* handleLoginUsingMagicLink(action) {
    let { magicLink } = action 

    if(!!!magicLink) {
        yield put(Actions.loginResponseMagicLink({
            isMagicLinkUsed: true,
            isMagicLinkSuccess: false
        }))
    }else {
        try {
            const response = yield call(Phi.User.magicLinkLogin, Phi.User, magicLink)
            if (response && response.profile) {
                // Persistent Login by saving the JWT token in cookies
                if(action.persistent.selected) {
                let cookies = action.persistent.cookies
                cookies.set('token', JSON.stringify(Phi.getSession()), {path: '/'})
                cookies.set('profile', Phi.Storage.getItem('profile'), {path: '/'})
                cookies.set('custom', Phi.Storage.getItem('custom'), {path: '/'});
                cookies.set('roles', Phi.Storage.getItem('roles'), {path: '/'})
                }
    
                yield put(Actions.loginResponse({ ok: true, error: false, message: 'Logged In Successfully' }))
                yield put(Actions.loginResponseMagicLink({ isMagicLinkUsed: true, isMagicLinkSuccess: true }))
            }
            else if (!!!response.ok && !!response.error && response.errorCode === 403) {
                yield put(Actions.loginResponse({ ok: false, error: true, errorCode: 403, message: 'Authorization failure: User is not authorized'}))
                yield put(Actions.loginResponseMagicLink({ isMagicLinkUsed: true, isMagicLinkSuccess: false }))
            }
            else {
                yield put(Actions.loginResponse({ ok: false, error: true, errorCode: 401, message: 'Authentication failure. Incorrect username or password'}))
                yield put(Actions.loginResponseMagicLink({ isMagicLinkUsed: true, isMagicLinkSuccess: false }))
            }
        }catch(e) {
            yield put(Actions.loginResponse({ ok: false, error: true, errorCode: 500, message: 'Something went wrong', isMagicLinkApplied: true}))
            yield put(Actions.loginResponseMagicLink({ isMagicLinkUsed: true, isMagicLinkSuccess: false }))
        }
    }
}
  
function* handleLogout(action) {
    Phi.User.logout()
    let isAuthenticated = Phi.User.isAuthenticated()
    yield put(Actions.resetOrganization())
    yield put(Actions.resetStudent())
    if (!!isAuthenticated) {
        yield put(Actions.loginResponse({ok: true, error: false, message: 'Logged In' }))
    }
    else {
        yield put(Actions.loginResponse({ok: false, error: true, errorCode: 0, message: 'Logout User'}))
    }
}

function* fetchStudentList(action) {
    yield put(Actions.setLoader())
    try {
      let response = yield call(Phi.Organization.fetchStudentList, Phi.Organization, action.payload)
      if (!!response && !!response[0]) {
        response = Object.assign({}, { students: JSON.parse(response[0].students) }, { total: response[0].count }, { studentHeader: action.payload })
        yield put(Actions.storeStudentList(response))
      } else {
        yield put(Actions.storeStudentList({students: [], total: 0, studentHeader: action.payload }))
      }
    } catch (error) {
      console.error("error fetching student list", error)
    }
    yield put(Actions.unsetLoader())
}

function* getStudentReport(action) {
    const { reportType, config } = action
    const studentName = config.studentName
    const studentId = config.studentId
    const reportResponse = yield call(Phi.User.getStudentReport, Phi.User, reportType, config)

    if (reportResponse && !!!reportResponse.error && reportResponse.data) {  
        if (config.type === 'pdf') {
            FileSaver.saveAs(reportResponse.data, `${studentName === undefined || studentName === null ? reportType:studentName}_${studentId}.pdf`)      
        } else {
            yield put(Actions.loadReport(reportResponse.data))
        }        
    }
    else if (!!!reportResponse || reportResponse.error) {
        if (config.type === 'html') {
            yield put(Actions.loadStudentReport('<p>No Data to show</p>'))
        }        
    }
    yield put(Actions.unsetLoader())    
}

// const getPercent = (total = 1) => (partial = 0) => Math.floor(partial/total * 100)

function* getBulkStudentReport(action) {
    const { reportType, config } = action
    const { studentArr, startNodeId } = config
    yield put(Actions.setLoader('Preparing to download reports'))
    let reportConfig, reportResponse

    let zipfile = new JSZip()

    let reportList = ['physical', 'ent', 'eye', 'growth', 'dental']
        const studentHeader = {
            "inLimit": 10000,
            "inOffset": 0,
            startNode: startNodeId
        }

    let wholeSchoolStudentArr = []
    let studentResponse = null

    studentResponse = yield call(Phi.Organization.fetchStudentList, Phi.Organization, studentHeader)
    if(studentResponse && studentResponse.length && studentResponse[0]){
        wholeSchoolStudentArr = JSON.parse(studentResponse[0].students).filter(report => report.report_status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED)
    }

    try {
        let schoolStudent = null
        if(studentArr && studentArr.length) {
            schoolStudent = wholeSchoolStudentArr.filter((d,i) => studentArr.includes(d.hsg_id))
            wholeSchoolStudentArr = schoolStudent
        }

    }catch (e){
        //console.log("Check this out!!!", e)
        
    }

    if (reportType === 'all') {
        
        for (let Id in wholeSchoolStudentArr) {
            reportConfig = { startNodeId, studentId: wholeSchoolStudentArr[Id].hsg_id, type: 'pdf' }
            for (let i in reportList) {
                reportResponse = yield call(Phi.User.getStudentReport, Phi.User, reportList[i], reportConfig)
                if (reportResponse && !!!reportResponse.error && reportResponse.data) {
                    zipfile.file(`${wholeSchoolStudentArr[Id].firstname}-${wholeSchoolStudentArr[Id].class}-${wholeSchoolStudentArr[Id].section}-${wholeSchoolStudentArr[Id].hsg_id}-${reportList[i]}.pdf`, reportResponse.data, {binary: true})
                }
            }
            yield put(Actions.setLoader(`Preparing ${parseInt(Id,10)+1} of ${wholeSchoolStudentArr.length} reports`))
        }
    }
    else {
        for (let Id in wholeSchoolStudentArr) {
            reportConfig = { startNodeId, studentId: wholeSchoolStudentArr[Id].hsg_id, type: 'pdf' }
            reportResponse = yield call(Phi.User.getStudentReport, Phi.User, reportType, reportConfig)
            if (reportResponse && !!!reportResponse.error && reportResponse.data) {
                zipfile.file(`${wholeSchoolStudentArr[Id].firstname}-${wholeSchoolStudentArr[Id].class}-${wholeSchoolStudentArr[Id].section}-${wholeSchoolStudentArr[Id].hsg_id}.pdf`, reportResponse.data, {binary: true})
            }  
            yield put(Actions.setLoader(`Preparing ${parseInt(Id,10)+1} of ${wholeSchoolStudentArr.length} reports`))          
        }
    }
    

    if (wholeSchoolStudentArr && wholeSchoolStudentArr.length) {
        let fileObj = yield zipfile.generateAsync({type : "blob"})
        yield FileSaver.saveAs(fileObj, `bulk.zip`)      
    }
    
    yield put(Actions.unsetLoader())
}

function* changePassword(action){
    yield put(Actions.setLoader(`You will be logged out, Please login with the new password`))
    const userid = Phi.User.profile().user_id
    const config = {password: action.password}
    const response = yield call(Phi.User.put, Phi.User, {userid, ...config})
    if (response && !!!response.error) {
        const emptyFormData = {password1: null, password2: null}
        yield put(Actions.initializeForm(emptyFormData))
        yield put(Actions.logoutUser())
    } else {
        toast.error("Something went wrong, password change failed", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true
        });
    }
    yield put(Actions.unsetLoader())
}

function* fetchCustomStudentList(action) {
    if(!action.hideLoader){
        yield put(Actions.setLoader())
    } 
    try {
      let response = yield call(Phi.Organization.fetchCustomStudentList, Phi.Organization, action.payload)
      if (!!response && !!response[0]) {
        response = Object.assign({}, { students: JSON.parse(response[0].students) }, { total: response[0].count }, { studentHeader: action.payload })
        yield put(Actions.storeStudentList(response))
      } else {
        yield put(Actions.storeStudentList({students: [], total: 0, studentHeader: action.payload }))
      }
    } catch (error) {
      console.error("error fetching student list", error)
    }
    yield put(Actions.unsetLoader())
}

function* addStudentMedicalInfo(action){
    const userid = Phi.User.profile().user_id
    const config = {newCustom: JSON.stringify(action.custom), hsgId: action.uuid, userid: userid}
    const response = yield call(Phi.User.put, Phi.User, config)
    if (response && !!!response.error) {
        yield put(Actions.toggleDataUpdateFlag())
    } else {
        toast.error("Something went wrong, password change failed", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true
        });
    }
    yield put(Actions.unsetLoader())
}

function* postStudentEpisodeInfo(action){
    const userId = Phi.User.profile().user_id
    const config = {episodeCustom: JSON.stringify(action.customJson), type: action.episodeType, studentId: action.studentId, userId: userId}
    const response = yield call(Phi.User.postEpisode, Phi.User, config)
    if (response && !!!response.error) {
        yield put(Actions.toggleDataUpdateFlag())
    } else {
        toast.error("Something went wrong, password change failed", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true
        });
    }
    yield put(Actions.unsetLoader())
}


function* fetchStudentEpisodeSearch(action){

    const config = {
        "inLimit": action.header.inLimit,
        "inOffset": action.header.inOffset,
        "inSortField": action.header.inSortField,
        "inSortBy": action.header.inSortBy,
        "inStudentId": action.header.inStudentId,
        "inOrganizationId": action.header.inOrganizationId,
        "inSearchString": action.header.inSearchString,
        "inCustomFilter": action.header.inCustomFilter ? action.header.inCustomFilter.toString() : '' 
    }
    const response = yield call(Phi.Event.studentEpisodeSrearch, Phi.Event, config)
    if (response && !!!response.error) {
        yield put(Actions.storeStudentEpisodeSearch({
            episodes: JSON.parse(response.episodes),
            total: response.total,
            header: config
        }))
    } else {
        yield put(Actions.storeStudentEpisodeSearch({
            episodes: [],
            total: 0,
            header: config
        }))
    }
}


// new api to fetch the api/v2/2 //




// new vaccination api for fetching the data//




function* getVaccination(action) {
    const response = yield call(Phi.Organization.getVaccination, Phi.Organization);

    if(Boolean(response) && response.ok) {
        yield put(Actions.responseVaccination({ok: true, data: response.data.results}));
    }

    else {
        yield put(Actions.responseVaccination({ok: false}));
    }
}



function* fetchChildList(action) {
    const childList = [];

    const userId = action.params.userId
    const currentStuId = action.params.studentId

    //const responseChild = yield call(Phi.User.getUserAssociation, Phi.User, {userId: userId});
  const responseChild = yield call(Phi.User.getParentStudentAssociation, Phi.User, {userId: userId});
    
    if(Boolean(responseChild)) {
      let index = 0
        // Setting up selected student (Durring parent login from third party portal)
        if (currentStuId) {
            try {
                var val = parseInt(currentStuId)
                var filteredObj = childList.find(function(item, i){
                    if(item.userId === val){
                        index = i;
                        return i;
                    }
                });
            }catch(e){
                //Catch Empty!!! Raise Error 
                yield put(Actions.responseChildList({ ok: false, error: 'Failed to fetch any associated students' }));
            }
        }
        yield put(Actions.responseChildList({ ok: true, childList: responseChild, selectedChild: index }));
    }

    else {
        yield put(Actions.responseChildList({ ok: false, error: 'Failed to fetch any associated students' }));
    }
}

function *fetchStudentAssessmentStatus(action)
{
     const config = {
        "studentId":  action.header.studentId,
        "inEventTrackId": action.header.inEventTrackId
    }
    const response = yield call(Phi.Event.studentAssessmentStatus, Phi.Event, config)
    if (response && !!!response.error) {
        yield put(Actions.storeStudentAssessmentStatus({
            studentAssessmentStatus: response.results,
            header: config
        }))
    } else {
        yield put(Actions.storeStudentAssessmentStatus({
            studentAssessmentStatus: [],
            header: config
        }))
    }
}

function *fetchStudentProfileSearch(action){
    const config = {
        "orgId":  action.header.inOrganizationId,
        "in_hsg_id": action.header.inSearchString
    }
    const response = yield call(Phi.Event.studentProfileSearch, Phi.Event, config)
    if (response && !!!response.error) {
        yield put(Actions.storeStudentProfileSearch({
            students: JSON.parse(response.students),
            header: config
        }))
    } else {
        yield put(Actions.storeStudentProfileSearch({
            students: [],
            header: config
        }))
    }
}
function* fetchClinicStudentSearch(action){

    const config = {
        "inLimit": action.header.inLimit,
        "inOffset": action.header.inOffset,
        "inSortField": action.header.inSortField,
        "inSortBy": action.header.inSortBy,
        "inStudentId": action.header.inStudentId,
        "inOrganizationId": action.header.inOrganizationId,
        "inSearchString": action.header.inSearchString,
        "inCustomFilter": action.header.inCustomFilter ? action.header.inCustomFilter.toString() : '' 
    }
    const response = yield call(Phi.Event.clinicStudentSearch, Phi.Event, config)
    if (response && !!!response.error) {
        yield put(Actions.storeClinicStudentSearch({
            students: JSON.parse(response.students),
            total: response.total,
            header: config
        }))
    } else {
        yield put(Actions.storeClinicStudentSearch({
            students: [],
            total: 0,
            header: config
        }))
    }
}

function* fetchClinicEpisodeStats(action){

    const config = {
        "inOrganizationId": action.inOrganizationId,
        "inStatLimit": action.inStatLimit,
        "inClass": action.inClass,
        "inSection": action.inSection,
    }
    const response = yield call(Phi.Event.clinicEpisodeStats, Phi.Event, config)
    if (response && !!!response.error) {
        yield put(Actions.storeClinicEpisodeStats({
            stats: response
        }))
    } else {
        yield put(Actions.storeClinicEpisodeStats({
            stats: []
        }))
    }
}

function* fetchNurseMeta(){

    const response = yield call(Phi.Metadata.fetchNurseMeta, Phi.Metadata, {timestamp: 1262284200})
    if (response && !!!response.error) {
        yield put(Actions.storeNurseMeta({
           response
        }))
    } else {
        yield put(Actions.storeNurseMeta({
            response: []
        }))
    }
}

// Saga Watcher
export function* watchUserActions() {
    yield* [
        takeEvery(Types.POST_STUDENT_EPISODE_INFO, postStudentEpisodeInfo),
        takeEvery(Types.LOGIN_USER, handleLogin),
        takeEvery(Types.LOGOUT_USER, handleLogout),
        takeEvery(Types.FETCH_STUDENT_LIST, fetchStudentList), 
        takeEvery(Types.GET_STUDENT_REPORT, getStudentReport), 
        takeEvery(Types.GET_BULK_STUDENT_REPORT, getBulkStudentReport),
        takeEvery(Types.CHANGE_PASSWORD, changePassword),
        takeEvery(Types.FETCH_CUSTOM_STUDENT_LIST, fetchCustomStudentList),
        takeEvery(Types.ADD_STUDENT_MEDICAL_INFO, addStudentMedicalInfo),
        takeEvery(Types.FETCH_NURSE_META, fetchNurseMeta),

        takeLatest(Types.FETCH_STUDENT_EPISODE_SEARCH, fetchStudentEpisodeSearch),
    
        takeLatest(Types.FETCH_CLINIC_STUDENT_SEARCH, fetchClinicStudentSearch),
        takeLatest(Types.FETCH_STUDENT_PROFILE_SEARCH, fetchStudentProfileSearch),
        takeLatest(Types.FETCH_STUDENT_ASSESSMENT_STATUS, fetchStudentAssessmentStatus),
        takeLatest(Types.FETCH_CLINIC_EPISODE_STATS, fetchClinicEpisodeStats),
        takeLatest(Types.LOGIN_USING_MAGIC_LINK, handleLoginUsingMagicLink),

        // for vaccination drive //

        takeEvery(Types.FETCH_VACCINATION, getVaccination),
        takeEvery(Types.FETCH_CHILD_LIST, fetchChildList),
    ]
}